import styled from 'styled-components';
import { SIZES } from 'common/constants/sizes';
import { cssWhiteSection } from 'components/base/common-styles';

export const StyledEmptyStateOverlayHeader = styled.div`
  font-size: 2rem;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  font-weight: regular;
  background: #fff;
`;

export const StyledEmptyStateOverlayDescription = styled.div`
  font-size: ${SIZES.large};
  text-align: center;
  background: #fff;
  padding: 0.5rem;
`;

export const StyledEmptyStateOverlayActions = styled.div`
  margin-top: 2rem;
`;

export const StyledEmptyStateOverlay = styled.div`
  ${cssWhiteSection};
  min-height: 50rem;
  display: flex;
  flex-direction: column;
  font-size: ${SIZES.medium};

  background-image: ${({ background }) => `url(${background})`};
  background-size: 90%;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #000;
  height: 100%;
  filter: opacity(0.9);
`;
